import fetch             from './utils/browser-fetch';
import busyActionFactory from './busy';
// import { addError }      from './errors-dux';
// import Errors            from './errors';
import Locale            from './locale';

import { routeTo } from './routing-dux';
/*******************************************************************************
 * Initial state
 */
const initialState = {
    authenticated: false,
    locale: { code: 'en-US' }, // fallback to English if undefined
    privacyNotice: {
        hasAcknowledged: false,
        version: 0
    }
};


/*******************************************************************************
 * Non-async action types
 */
export const SET_USER_DATA = 'SET_USER_DATA';
export const BUSY_LOGGING_OUT = 'BUSY_LOGGING_OUT';
export const USER_LOGOUT = 'USER_LOGOUT';


/*******************************************************************************
 * Reducer
 */
export default function userData( state = initialState, action ) {
    /***************************************************************************
      WARNING: This reducer saves the new state to sessionStorage in addition
                to returning it from the function. Do not use "return"
                statements inside of the switch (except the default case).
    ***************************************************************************/

    let newState = null;
    switch ( action.type ) {

        case SET_USER_DATA:
            newState = {
                ...state,
                ...action.userData
            };
            break;

        case BUSY_LOGGING_OUT:
            newState = {
                ...state,
                busyLoggingOut: action.busy
            };
            break;

        default:
            return state;
    }

    // Update the lang attribute on the html tag.
    if ( newState.locale ) {
        Locale.updateLang( newState.locale.code || newState.locale.locale, newState.locale.dir );
    }

    sessionStorage.setItem( 'userState', JSON.stringify( newState ) );
    fetch.setSessionId( newState.sessionId );

    return newState;
}

/*******************************************************************************
 * Action creators
 */
export function getSessionUserData( defaultLocale ) {
    return dispatch => {
        return new Promise( ( resolve ) => {
            const sessionUserState = JSON.parse( sessionStorage.getItem( 'userState' ) ) || {};

            sessionUserState.loaded = true;
            sessionUserState.locale = sessionUserState.locale || { code: defaultLocale.code };

            dispatch( setUserData( sessionUserState ) );

            resolve();
        } );
    };
}

export function setUserData( userData ) {
    return {
        type: SET_USER_DATA,
        userData
    };
}

export function resetUserData() {
    return {
        type: USER_LOGOUT
    };
}

const busyLoggingOut = busyActionFactory( BUSY_LOGGING_OUT );
export function logout() {
    return ( dispatch, getState ) => {
        dispatch( busyLoggingOut( true ) );
        return fetch( '/api/v1.0/logout', { noparse: true } )
            .then( () => {
                const state = getState();
                const ssoLogoutType = state.ssoAuthenticated.ssoLogoutType;

                // Delete session cookie
                document.cookie = 'JSESSIONID=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

                // If user SSOd into the site, redirect to SSO logout message, otherwise redirect
                // to login page
                if ( ssoLogoutType !== 'login' ) {
                    dispatch( routeTo( '/sso-logout' ) );
                } else {
                    dispatch( routeTo( '/login' ) );
                }

                dispatch( resetUserData() );
                fetch.setSessionId( null );
                dispatch( busyLoggingOut( false ) );
                //dispatch( routeTo( '/login' ) );

                // Delete sessionStorage
                // This is not getting deleted unless it comes after the Redux dispatches
                sessionStorage.removeItem( 'userState' );
            } );
    };
}


export function refreshProgramNames() {
    return ( dispatch, getState ) => {
        return fetch( '/api/v1.0/user/program-names' )
            .then( ( participantRules ) => {
                dispatch( setUserData( { ...getState().userData, participantRules: participantRules } ) );
            } );
    };
}


export function savePrivacyAcknowledgment() {
    return ( dispatch, getState ) => {
        const userData = getState().userData;

        return fetch( '/api/v1.0/user/acknowledge-privacy-notice', { method: 'put' } )
            .then( () => {
                userData.privacyNotice.hasAcknowledged = true;
                dispatch( setUserData( userData ) );
            } )
            .catch( ( error ) => {
                throw error;
            } );
    };
}
